<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="title">
<p class="bk">Convenient Disposal</p>
<p class="sert">A Posadas County Mystery</p>
<p class="bkau">Steven F. Havill</p>
<p class="bkpub">Poisoned Pen Press</p>
<p class="bkpub"><img alt="" src="ppp-logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pppcondispos002.vue?1bb680fc